export default (configuratorItems = [], defaultSelectedItem = 0) => ({
	internal: {
		configuratorItems: configuratorItems,
		selectedItem: configuratorItems[0].id,
	},

	cache: {
		selectedItemObj: {},
	},

	init() {
		console.log(configuratorItems);

		let defaultItemObj = null;

		if(this.hasPreSelectedSize){
			defaultItemObj = configuratorItems.find(
				(item) => {
					const width = this.selectedWidth;
					const height = this.selectedHeight;
					const depth = this.selectedDepth;
					let condition = true;
					if(width && item.width){
						condition = condition && item.width == width;
					}

					if(height && item.height){
						condition = condition && item.height == height;
					}

					if(depth && item.depth){
						condition = condition && item.depth == depth;
					}

					return condition;
				}
			);
		}

		if(!defaultItemObj){
			defaultItemObj = configuratorItems.find(
				(item) => item.id == defaultSelectedItem
			);
		}
		if (defaultItemObj) {
			this.internal.selectedItem = defaultItemObj.id;
		}
		this.$watch('internal.selectedItem', (_) => {
			this.updateSelectedItemObj();
		});
		this.updateSelectedItemObj();
	},

	updateSelectedItemObj() {
		this.cache.selectedItemObj = this.internal.configuratorItems.find(
			(item) => {
				return item.id == this.internal.selectedItem;
			}
		);
	},

	p() {
		if (this.cache.selectedItemObj) {
			return this.cache.selectedItemObj;
		} else {
			return this.internal.configuratorItems[0];
		}
	},

	capitalize(str) {
		if (typeof str === 'string') {
			return str.charAt(0).toUpperCase() + str.slice(1);
		}
		return str;
	},

	generateDimensionLabelString() {
		const h = this.p().height;
		const w = this.p().width;
		const d = this.p().depth;

		let a = '';
		let b = '';
		let i = 0;
		[
			{ n: w, m: 'Szélesség' },
			{ n: d, m: 'Mélység' },
			{ n: h, m: 'Magasság' },
		].forEach(({ n, m }) => {
			if (n !== 0) {
				if (i !== 0) {
					a += ` \u00D7 ${n}`;
					b += ` \u00D7 ${m}`;
				} else {
					a += `${n}`;
					b += `${m}`;
				}
				i++;
			}
		});

		return `Méret: ${a} cm (${b})`;
	},

	hasPreSelectedSize(){
		const params = new URL(document.location).searchParams;
		return params.has('szelesseg') || params.has('magassag') || params.has('melyseg');
	},


	get selectedWidth(){

		const params = new URL(document.location).searchParams;
		return params.get('szelesseg');
	},

	get selectedHeight(){
		const params = new URL(document.location).searchParams;
		return params.get('magassag');
	},

	get selectedDepth(){
		const params = new URL(document.location).searchParams;
		return params.get('melyseg');
	}
});
